import * as rules from './rules';
import { ConfigType, configIsValid } from './types';

export const createValidator = (config: ConfigType | undefined) => {
  if (configIsValid(config)) {
    return (pw: string) => rules.getErrors(rules.runTests(config, pw));
  }
  return () => [];
};

// returns boolean | undefined if the first password is blank
export const doPasswordsMatch = (
  firstPassword: string,
  secondPassword = '',
) => {
  if (firstPassword === '') {
    return undefined;
  }
  return secondPassword === '' ? false : firstPassword === secondPassword;
};

export const passwordIsValid = (config: ConfigType, password = '') => {
  const results = rules.runTests(config, password);
  const errors = rules.getErrors(results);
  return errors.length === 0;
};
